export const TestActionTypes = {
    ADD_TEST_DETAILS:"ADD_TEST_DETAILS",
    UPDATE_TEST_DETAILS:"UPDATE_TEST_DETAILS",
    INC_SCREEN_COUNT:"INC_SCREEN_COUNT"
}